import React from "react";
import { useTranslate } from "react-admin";
import { DvirDefectDto } from "../types";
import "./DefectField.css";

interface Props {
  record?: DvirDefectDto;
  label: string;
}

export const DefectField = ({ record }: Props) => {
  const translate = useTranslate();
  if (!record) {
    return null;
  }

  return (
    <div className="defect-field">
      <div className="first-row-info">
        <div>
          <div className="info-label">
            {translate("resources.assets-dvir-vehicle-history.labels.area")}
          </div>
          <div>{record.area}</div>
        </div>
        <div>
          <div className="info-label">
            {translate("resources.assets-dvir-vehicle-history.labels.point")}
          </div>
          <div>{record.point}</div>
        </div>
      </div>
      <div className="defect-description">{record.defectDescription}</div>
    </div>
  );
};
